import React, { FunctionComponent } from "react";
import makeStyles from "@mui/styles/makeStyles";
import cs from "classnames";
import {
  SingleRaceRecord,
  DsqRecord,
  TeamRaceRecord,
  instanceOfTeamRecord,
  ChallengeFormula,
  instanceOfSingleRaceRecord,
} from "/src/domain/challenges/ChallengeProtocolData";
import { MultipleTrackView, TrackView } from "./TrackView";

export type RecordViewInfoProps = {
  className?: string;
  record: TeamRaceRecord | SingleRaceRecord | DsqRecord;
  challengeType: ChallengeFormula;
  isExpanded: boolean;
};

export const RecordViewInfo: FunctionComponent<RecordViewInfoProps> = ({
  className,
  record,
  challengeType,
  isExpanded,
}) => {
  const classes = useStyles();

  return (
    <div className={cs(className, classes.container)}>
      {instanceOfTeamRecord(record) ? (
        record.records.map((result: SingleRaceRecord | DsqRecord) => {
          return (
            <div className={classes.race} key={result.trackId}>
              {challengeType === ChallengeFormula.TEAM_MAX_DISTANCE &&
              instanceOfSingleRaceRecord(result) ? (
                <MultipleTrackView
                  record={result}
                  challengeType={challengeType}
                  isExpanded={isExpanded}
                />
              ) : (
                <TrackView record={result} />
              )}
            </div>
          );
        })
      ) : (
        <div className={classes.race}>
          {(challengeType === ChallengeFormula.MAX_DISTANCE || challengeType === ChallengeFormula.VELO_WITH_POINTS || challengeType === ChallengeFormula.CARS_MAX_DISTANCE) &&
          instanceOfSingleRaceRecord(record) ? (
            <MultipleTrackView
              record={record}
              challengeType={challengeType}
              isExpanded={isExpanded}
            />
          ) : (
            <TrackView record={record} />
          )}
        </div>
      )}
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    padding: "1rem 2rem",
  },
  race: {
    marginBottom: "1rem",
  },
});
